<template>
  <div class="charts">
    <div class="select-searchmain1">
      <div class="earch-input">
        <div class="input-li2">
          <!-- <p>查询日期：</p> -->
          <el-date-picker
            size="small"
            style="width: 100%"
            v-model="dates"
            value-format="yyyy-MM"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="input-li">
          <!-- <p>选择辖区：</p> -->
          <el-select
            size="small"
            style="width: 100%"
            v-model="searchParams.jurisdiction"
            clearable
            placeholder="请选择辖区"
          >
            <el-option
              v-for="item in jurisdictions"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input-li">
          <!-- <p>选择辖区：</p> -->
          <el-select
            size="small"
            style="width: 100%"
            v-model="searchTypes"
            collapse-tags
            placeholder="选择种类"
            multiple
          >
            <el-option
              v-for="item in types"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-action">
        <el-button
          size="small"
          icon="el-icon-search"
          type="primary"
          @click="getViews()"
          >查询</el-button
        >
        <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
      </div>
    </div>
    <div class="chart-content">
      <div class="chart-card">
        <div class="chart-title">
          <el-radio-group v-model="dataType" @change="toogleType" size="small">
            <el-radio-button label="outPut">产生</el-radio-button>
            <el-radio-button label="disPos">处置</el-radio-button>
            <el-radio-button label="storage">贮存</el-radio-button>
          </el-radio-group>

          <el-radio-group
            v-model="chartType"
            @change="toogleChart"
            size="small"
          >
            <el-radio-button label="饼图"></el-radio-button>
            <el-radio-button label="折线图"></el-radio-button>
            <el-radio-button label="柱状图"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-main" id="danger-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      searchParams: {
        startDate: "",
        endDate: "",
        jurisdictions: null,
      },
      searchTypes: [],
      dataType: "outPut",
      dataSource: [],

      manageCategory: [],
      industries: [],
      types: [],
      jurisdictions: [],
      chartType: "饼图",
      dates: [],
      pieData: [],
      barData: [],
    };
  },
  methods: {
    //切换图表类型
    toogleChart() {
      if (!document.getElementById("danger-chart")) return false;
      echarts.init(document.getElementById("danger-chart")).dispose();
      if (this.chartType == "饼图") {
        this.drawPieCharts();
      } else {
        this.drawBarCharts();
      }
    },
    //切换数据类型
    toogleType() {
      this.getViews();
    },
    getParams() {
      const url = this.$api.statistics.getDangerTypeParams;
      this.$axios.get(url, null, false).then((res) => {
        if (res.data.code == 0) {
          let { types, jurisdictions } = res.data.data;

          this.types = types;
          this.jurisdictions = jurisdictions;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getViews() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }
      const params = {
        ...this.searchParams,
      };
      if (this.searchTypes && this.searchTypes.length > 0) {
        params.types = this.searchTypes.join(",");
      }

      let url = "";
      switch (this.dataType) {
        case "outPut":
          url = this.$api.statistics.getDangerTypeOutPut;
          break;
        case "disPos":
          url = this.$api.statistics.getDangerTypeDisPos;
          break;
        case "storage":
          url = this.$api.statistics.getDangerTypeStorage;
          break;
      }
      // const url = this.$api.statistics.getDangerDataView;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { barData, pieData } = res.data.data;

          this.barData = barData;
          this.pieData = pieData;

          this.toogleChart();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    drawPieCharts() {
      const thisDataType = this.dataType;

      const pieData = this.pieData;

      const option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {
          //   console.log(params);
          // }
          formatter: function (params) {
            // 获取数据
            const jurisdictions = params.data.jurisdiction;
            let dataType = "产生量";
            if (thisDataType == "disPos") {
              dataType = "处置量";
            } else if (thisDataType == "storage") {
              dataType = "贮存量";
            }
            let tooltipContent = "";
            if (jurisdictions) {
              let thColor = "#fff";
              // 构建tooltip内容
              tooltipContent +=
                '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
              tooltipContent +=
                '<tr style="background-color:' +
                params.color +
                ";color:" +
                thColor +
                '">';
              tooltipContent +=
                '<th style="border: 1px solid ' +
                params.color +
                '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
              tooltipContent +=
                '<th style="border: 1px solid ' +
                params.color +
                '; padding: 5px;">' +
                dataType +
                " （吨）</th>"; // 设置表头边框和内边距
              tooltipContent += "</tr>";
              jurisdictions.forEach(function (jurisdiction) {
                tooltipContent += "<tr>";
                tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
                tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.value}</td>`; // 设置单元格边框和内边距
                tooltipContent += "</tr>";
              });
              tooltipContent += "</table></div>";
            }

            let title = `<div style="margin-bottom:7px"> ${params.marker} ${params.data.name} <br />${dataType} : ${params.value} 吨 </div> `;
            return `${title}  ${tooltipContent}`;
          },
        },
        legend: {
          top: "16px",

          // orient: ",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 吨",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("danger-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawBarCharts() {
      let chartType = this.chartType == "柱状图" ? "bar" : "line";
      const xData = [];
      const sData = {};
      this.barData.forEach((monthData) => {
        xData.push(monthData.date);
        monthData.value.forEach(({ type, value, jurisdiction }) => {
          if (!sData[type]) sData[type] = [];
          sData[type].push({
            value,
            jurisdiction,
          });
        });
      });

      const series = [];
      for (let type in sData) {
        series.push({
          name: type,
          type: chartType,
          data: sData[type],
          smooth: true,
        });
      }
      const legendData = Object.keys(sData);

      const thisDataType = this.dataType;
      let option = {
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: series.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            // 获取数据
            const jurisdictions = params.data.jurisdiction;
            let dataType = "产生量";
            if (thisDataType == "disPos") {
              dataType = "处置量";
            } else if (thisDataType == "storage") {
              dataType = "贮存量";
            }
            let tooltipContent = "";
            if (jurisdictions) {
              let thColor = "#fff";
              // 构建tooltip内容
              tooltipContent +=
                '<div> <table style="text-align:center;border-collapse: collapse;">'; // 设置表格边框折叠
              tooltipContent +=
                '<tr style="background-color:' +
                params.color +
                ";color:" +
                thColor +
                '">';
              tooltipContent +=
                '<th style="border: 1px solid ' +
                params.color +
                '; padding: 5px;">辖区</th>'; // 设置表头边框和内边距
              tooltipContent +=
                '<th style="border: 1px solid ' +
                params.color +
                '; padding: 5px;">' +
                dataType +
                " （吨）</th>"; // 设置表头边框和内边距
              tooltipContent += "</tr>";
              jurisdictions.forEach(function (jurisdiction) {
                tooltipContent += "<tr>";
                tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.jurisdiction}</td>`; // 设置单元格边框和内边距
                tooltipContent += `<td style="border: 1px solid ${params.color}; padding: 5px;">${jurisdiction.value}</td>`; // 设置单元格边框和内边距
                tooltipContent += "</tr>";
              });
              tooltipContent += "</table></div>";
            }

            let title = `<div style="margin-bottom:7px"> ${params.marker}   ${params.seriesName} <br /> ${params.name}${dataType} : ${params.value} 吨 </div> `;
            return `${title}  ${tooltipContent}`;
          },
          // axisPointer: {
          //   type: "none",
          // },
        },
        legend: {
          data: legendData,
          // align: "right",
          //   right: 10,
          top: "16px",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 35,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value} 吨",
            },
            axisTick: {
              show: false,
            },

            splitLine: {
              show: false,
            },
          },
        ],
        series,
      };

      const myChart = echarts.init(document.getElementById("danger-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");
    this.dates.push(lastMonth, currentMonth);
    this.getParams();
    this.getViews();
  },
};
</script>

<style lang="scss" scoped>
.charts {
  height: 100%;
}

.chart-content {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 60px);

  .chart-card {
    border: 1px solid #909399;
    width: 96%;
    margin: 10px 1%;
    height: calc(100% - 30px);
    border-radius: 3px;

    .chart-title {
      width: 100%;

      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-bottom: 1px solid #909399;
      padding: 0px 10px;
    }

    .chart-main {
      width: 100%;
      height: calc(100% - 45px);
    }
  }
}

.select-searchmain1 {
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: inline-block;
    // width: 230px;
    text-align: center;
    height: 100%;
    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
